@if (dataSource) {
<mat-grid-list
    cols="1"
    rowHeight="120px"
    gutterSize="16"
>
    <mat-grid-tile>
        <div class="bordered-container no-padding justify-center">
            <div class="wrapper widget-full-width-height-2">
                @for (item of dataSource.indicatorOptions; track item) {
                <app-mdr-dashboards-indicator [element]="item"></app-mdr-dashboards-indicator>
                }
            </div>
        </div>
    </mat-grid-tile>
</mat-grid-list>
} @if (dataSource) {
<mat-grid-list
    cols="3"
    rowHeight="366px"
    class="m-t-16"
    gutterSize="16"
>
    <mat-grid-tile colspan="2">
        <div class="bordered-container align-center">
            <div class="chart-container">
                <app-mdr-dashboards-area-chart
                    [element]="dataSource.investigationSeverityTrend"
                    [tooltipWidth]="168"
                    [stacked]="true"
                    [emptyStateTitle]="'No investigations present'"
                    [bulletType]="'round'"
                    [fillOpacity]="1"
                    [colors]="dataSource.investigationSeverityTrend.colors"
                ></app-mdr-dashboards-area-chart>
            </div>
        </div>
    </mat-grid-tile>
    <mat-grid-tile
        colspan="1"
        rowspan="1"
    >
        <div class="bordered-container align-center">
            <div class="chart-container">
                <app-mdr-dashboards-bar-chart
                    [colors]="dataSource.huntOutcomes.colors"
                    [tooltipWidth]="237"
                    [element]="dataSource.huntOutcomes"
                    [categories]="dataSource.huntOutcomes.categories"
                    [height]="237"
                    [hasMarginTop]="false"
                    [width]="'100%'"
                    [emptyText]="'There are no ongoing threat hunts'"
                    [columnWidth]="'35%'"
                ></app-mdr-dashboards-bar-chart>
            </div>
        </div>
    </mat-grid-tile>
</mat-grid-list>
} @if (dataSource) {
<mat-grid-list
    cols="1"
    rowHeight="227"
    class="m-t-16"
    gutterSize="16"
>
    <mat-grid-tile>
        <div class="bordered-container align-center">
            <app-mdr-dashboards-table
                [mocked]="false"
                [element]="dataSource.recentInvestigations"
                [displayedColumns]="dataSource.recentInvestigations.columns"
            ></app-mdr-dashboards-table>
        </div>
    </mat-grid-tile>
</mat-grid-list>
} @if (dataSource) {
<mat-grid-list
    cols="1"
    rowHeight="227"
    class="m-t-16"
    gutterSize="16"
>
    <mat-grid-tile>
        <div class="bordered-container align-center">
            <app-mdr-dashboards-table
                [mocked]="false"
                [element]="dataSource.recentHunts"
                [displayedColumns]="dataSource.recentHunts.columns"
            ></app-mdr-dashboards-table>
        </div>
    </mat-grid-tile>
</mat-grid-list>
} @if (dataSource) {
<mat-grid-list
    cols="3"
    rowHeight="398px"
    class="m-t-16 m-b-25"
    gutterSize="16"
>
    <mat-grid-tile>
        <div class="bordered-container align-center">
            <app-mdr-dashboards-table
                [element]="dataSource.investigationResolution"
                [mocked]="false"
                [displayedColumns]="dataSource.investigationResolution.columns"
            ></app-mdr-dashboards-table>
        </div>
    </mat-grid-tile>
    <mat-grid-tile>
        <div class="bordered-container align-center">
            <app-mdr-dashboards-table
                [element]="dataSource.topInvestigationsHosts"
                [mocked]="false"
                [displayedColumns]="dataSource.topInvestigationsHosts.columns"
            ></app-mdr-dashboards-table>
        </div>
    </mat-grid-tile>
    <mat-grid-tile>
        <div class="bordered-container align-center">
            <app-mdr-dashboards-table
                [element]="dataSource.topInvestigationsSignature"
                [mocked]="false"
                [displayedColumns]="dataSource.topInvestigationsSignature.columns"
            ></app-mdr-dashboards-table>
        </div>
    </mat-grid-tile>
</mat-grid-list>
}
